import * as yup from 'yup';
import docs from './attachments';
import {
  acessoContraCheque,
  declaracao,
  declaracaoTipoRegime,
  tipoRegime,
  aceite,
  consentimentoDadosSensiveis,
  aceiteInss,
  declaracaoVeracidade,
} from './utils/rulesByKey';

export const PPISchema = yup.object({
  ...acessoContraCheque,
  ...declaracao,
  ...declaracaoTipoRegime,
  ...tipoRegime,
  ...aceite,
  ...consentimentoDadosSensiveis(),
  ...declaracaoVeracidade,
  ...docs.PPIDocs.rules,
  ...aceiteInss,
});

export const PPIInitialValues = {
  acessoContraCheque: '',
  tipoRegime: '',
  declaracao: false,
  aceiteInss: false,
  consentimentoDadosSensiveis: false,
  declaracaoTipoRegime: false,
  aceite: false,
  declaracaoVeracidade: false,
  ...docs.PPIDocs.initialValues,
};

export const PPIDocs = {
  ...docs.PPIDocs.docs,
};
